import { TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { Text } from "$components";
import CField, { CFieldInputProps } from "$forms/CField";
import useJStyles from "$hooks/useJStyles";
import { useStyles } from "../styles/CompanyForm.styles";

export default function NotesDetails() {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const classes = useStyles();
  const { jclasses } = useJStyles();

  return (
    <>
      <div className={jclasses.formSectionHead}>
        <Text type="h3">Notes</Text>
      </div>
      <div className={classes.formRow}>
        <CField
          label="Caractéristiques techniques de prise en charge"
          control={control}
          name="technicalNotes"
          error={errors.notes}
        >
          {(props: CFieldInputProps) => (
            <TextField
              variant="outlined"
              multiline
              minRows={3}
              style={{ width: "100%" }}
              {...props}
            />
          )}
        </CField>
      </div>
      <div className={classes.formRow}>
        <CField
          label="Remarques"
          control={control}
          name="notes"
          error={errors.notes}
        >
          {(props: CFieldInputProps) => (
            <TextField
              variant="outlined"
              multiline
              minRows={3}
              style={{ width: "100%" }}
              {...props}
            />
          )}
        </CField>
      </div>
    </>
  );
}
